import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialsModule } from '@library/common/materials';
import { PipesModule } from '@library/core/pipes';

import { DefaultErrorRoutingModule } from './default-error.routing';
import { DefaultErrorComponent } from './default.error.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialsModule,
    PipesModule,
    DefaultErrorRoutingModule,
  ],
  declarations: [
    DefaultErrorComponent,
  ],
  exports: [
    DefaultErrorComponent,
  ],
})
export class DefaultErrorModule { }
